import * as FileSaver from "file-saver";
import {DateTimeUtil} from "../js/util/DateTimeUtil";
import {BackOffice} from "../types/BackOffice";
import {BrokerKey} from "../types/BrokerKey";

//'use strict';
{
    var app = angular.module('tf.admin', ['ngTagsInput'])

        .controller('adminCtrl', ['$scope', '$state', '$http', '$stateParams', 'userConfig', '$uibModal', 'terms', function adminController($scope, $state, $http, $stateParams, userConfig, $uibModal, terms) {

            $state.userConfig = userConfig;

            if (userConfig.broker == 'TC') {
                $state.go('admin.userlist');
            } else {
                if (userConfig.features['SCREEN_USER_MAINT']) {
                    $state.go('admin.userMaintenance');
                } else if (userConfig.features['SCREEN_USER_LIST']) {
                    $state.go('admin.userlist');
                }
            }

            $scope.submitTicket = function (size) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'help/supportRequest/support.tpl.html',
                    resolve : {
                        userConfig : function () {
                            return userConfig;
                        }
                    },
                    controller: 'ReportAnIssueCtrl',
                    size: size
                });
            };
        }])

        .controller('userMaintenanceCtrl', ['$scope', '$state', '$http', '$stateParams', 'userConfig', 'Excel', '$timeout', 'currentUserService', function userMaintenanceController($scope, $state, $http, $stateParams, userConfig, Excel, $timeout, currentUserService) {

            $state.userConfig = userConfig;

            $scope.selectedUser = null;

            $scope.exportToExcel=function(tableId){
                var blob =  new Blob( [document.getElementById(tableId).innerHTML] , {type:'text/html'});
                FileSaver.saveAs(blob, "UserList.xls");
            };

            function isOMBroker(broker) {
                return (broker === BrokerKey.OPEN_TRADER) ||
                       (broker === BrokerKey.OPEN_MARKETS) ||
                       (broker === BrokerKey.BELLMONT)||
                       (broker === BrokerKey.FUTURE_ASSIST) ||
                       (broker === BrokerKey.ALLFIN) ||
                       (broker === BrokerKey.LIQUIDITY);
            }

            var livePrices = userConfig.backOffice === BackOffice.MORGANS || isOMBroker(userConfig.broker);
            var optionsAdviser = !isOMBroker(userConfig.broker);
            var equityAdviser = isOMBroker(userConfig.broker);
            var riskManager = !isOMBroker(userConfig.broker);
            var orderEntry = isOMBroker(userConfig.broker);

            const defaultNewUserData = {
              name : "",
                email : "",
                livePrices,
                equityAdviser,
                optionsAdviser,
                crm : false,
                riskManager,
                orderEntry,
                adminUser : false,
                error : false,
                errorMessage : "",
                success : false,
                successMessage : "User created"
            }

            $scope.newUserData = {
                ...defaultNewUserData
            };

            $scope.createNewUser = function (form) {
                var userData = {
                    name : $scope.newUserData.name,
                    email : $scope.newUserData.email,
                    livePrices : $scope.newUserData.livePrices,
                    equityAdviser : $scope.newUserData.equityAdviser,
                    optionsAdviser : $scope.newUserData.optionsAdviser,
                    riskManager : $scope.newUserData.riskManager,
                    orderEntry : $scope.newUserData.orderEntry,
                    crm : $scope.newUserData.crm,
                    orderAdviceAccess : $scope.newUserData.orderAdviceAccess,
                    adminUser : $scope.newUserData.adminUser,
                    orgIds : []
                };
                for (var i = 0; i < $scope.tags.length; i++) {
                    userData.orgIds = userData.orgIds.concat($scope.tags[i].id);
                }

                if (form.$invalid) {
                    return
                }

                $http.post("/tradefloor/api/user/adviser", userData).then(function ({data = {}, status}) {
                    $scope.newUserData = {
                        ...$scope.newUserData,
                        name : data.name,
                        email : data.email,
                        livePrices : data.livePrices,
                        equityAdviser : data.equityAdviser,
                        optionsAdviser : data.optionsAdviser,
                        riskManager : data.riskManager,
                        orderEntry : data.orderEntry,
                        crm : data.crm,
                        orderAdviceAccess : data.orderAdviceAccess,
                        adminUser : data.adminUser,
                        success : status === 200
                    };
                }).catch((response) => {
                    $scope.newUserData.success = false
                    $scope.newUserData.failMessage = response.data.message

                    $scope.tags = []
                });
            };

            $scope.userData = {
                name : null,
                email : null,
                id : null,
                existingBroker: null,
                isSelected : false
            };

            $scope.getOrgData = function() {
                $http.get("/tradefloor/api/org").then(function (response) {
                    $scope.flatOrg = response.data;
                });
            };

            if (userConfig.features['SCREEN_ORG_STRUCTURE'] || userConfig.features['SCREEN_USER_MAINT']) {
                $scope.getOrgData();
            }

            $scope.tags = [];

            $scope.loadAccessRoles = function($query) {
                var roles = $scope.flatOrg;
                return roles.filter(function (role) {
                    return (role.name.toLowerCase().indexOf($query.toLowerCase()) != -1 || role.key.toLowerCase().indexOf($query.toLowerCase()) != -1 || role.type.toLowerCase().indexOf($query.toLowerCase()) != -1);
                });
            };

            $scope.loadUserData = function (user) {
                $scope.selectedUser = user;
                var userId = user.id;
                $http.get("/tradefloor/api/org/" + userId).then(function (response) {
                    var data = response.data;
                    $scope.selectedUserDetail = data;
                    $scope.userData = {
                        name : user.displayName,
                        email : user.username,
                        contactNumber : user.contactNumber,
                        id : user.id,
                        existingBroker: user.existingBroker,
                        isSelected : true,
                        orderAdviceAccess : user.orderAdviceAccess

                    };
                    $scope.selectedUserTags = $scope.flatOrg.filter(function (role) {
                        for (var i = 0; i < $scope.selectedUserDetail.length; i++) {
                            if ($scope.selectedUserDetail[i].id == role.id) {
                                return true;
                            }
                        }
                    })
                });

            };

            $scope.deleteUser = function(user) {
                $http.delete("/tradefloor/api/user/" + user.id).then(function (response) {
                    var data = response.data;
                    $scope.userList = $scope.userList.filter(function(e) {
                        return e !== user;
                    });

                    $scope.userData = {
                        name : null,
                        email : null,
                        id : null,
                        contactNumber : null,
                        isSelected : false,
                        existingBroker: null

                    };

                    $scope.selectedUser = null;

                    $scope.loadUserList();
                });
            };

            $scope.updateUser = function () {
                var updatedUser = {
                    id: $scope.userData.id,
                    email: $scope.userData.email,
                    name: $scope.userData.name,
                    contactNumber : $scope.userData.contactNumber,
                    orgIds: [],
                    existingBroker: $scope.userData.existingBroker,
                    orderAdviceAccess : $scope.userData.orderAdviceAccess
                };
                for (var i = 0; i < $scope.selectedUserTags.length; i++) {
                    updatedUser.orgIds = updatedUser.orgIds.concat($scope.selectedUserTags[i].id);
                }
                $http.post("/tradefloor/api/user/" + updatedUser.id, updatedUser).then(function (response) {
                    var data = response.data;
                    $scope.newUserData.success = true;
                    $scope.userData = {
                        name: null,
                        email: null,
                        id: null,
                        existingBroker: null
                    };

                    $scope.selectedUser = null;

                    $scope.loadUserList();
                    currentUserService.refreshConfig()
                });
            };

            $scope.toggleSubsidy = function(user) {
                if (user.subsidised) {
                    $http.delete('/tradefloor/api/user/' + user.id + '/subsidy').then(function(response) {
                        user.subsidised = !user.subsidised;
                        $scope.loadUserList();
                    });
                } else {
                    $http.put('/tradefloor/api/user/' + user.id + '/subsidy').then(function(response) {
                        $scope.loadUserList();
                    });
                }
            };

            $scope.updateSummary = function() {
                var today = new Date();

                var newSummary = {
                    activated : 0,
                    subsidised : 0,
                    invoiceable : 0
                };

                $scope.userList.forEach(function(user) {

                    if (user.username.match(/.*@tradefloor\.com\.au/)) {
                        return;
                    }

                    if (user.subsidised) {
                        newSummary.subsidised++;
                    }

                    if (user.activatedDate != null) {
                        newSummary.activated++;
                        if (Math.ceil((today - new Date(user.activatedDate))/ (24 * 1000 * 3600)) >= 30 && user.subsidised) {
                            newSummary.invoiceable++;
                        }
                    }
                });

                $scope.summary = newSummary;
            };

            $scope.loadUserList = function() {
                $http.get('/tradefloor/api/user').then(function(response) {
                    $scope.userList = response.data.filter(function(u) {
                        return userConfig.super || !u.username.match(/.*@tradefloor\.com\.au/);
                    });

                    $scope.userList.forEach(function(user) {
                        user.subsidised = false;
                        user.hasBasic = false;
                        user.basicStatus = null;

                        user.bundles.forEach(function(b) {
                            if (b.name === 'tc_basic_subsidised') {
                                user.subsidised = true;
                            } else if (b.name === 'tc_basic_monthly') {
                                user.hasBasic = true;
                                user.basicStatus = b.status;
                            } else if (b.name === 'tc_basic_yearly') {
                                user.hasBasic = true;
                                user.basicStatus = b.status;
                            }
                        });

                        if (user.subsidised) {
                            user.level = 'Subsidised';
                        } else if (user.hasBasic) {
                            if (user.basicStatus === 'TRIALING') {
                                user.level = 'Basic - Trial';
                            } else if (user.basicStatus === 'ACTIVE') {
                                user.level = 'Basic - Paid';
                            } else {
                                user.level = 'Basic';
                            }

                        } else {
                            user.level = 'Free';
                        }
                    });

                    $scope.updateSummary();
                });
            };

            $scope.loadUserList();

            $scope.sort = {
                type : 'name', // set the default sort type
                reverse : false  // set the default sort order
            };

            $scope.searchUser   = '';     // set the default search/filter term
            $scope.userList = [];

            $scope.updateSummary();

            $scope.isOauth = currentUserService.isOauthAuthenticated();

        }])
        .controller('additionalSettingsCtrl', ['$scope', '$state', '$http', '$aside', 'uiGridConstants', 'uiGridExporterConstants', 'userConfig', 'currentUserService', function additionalSettingsController($scope, $state, $http, $aside, uiGridConstants, uiGridExporterConstants, userConfig, currentUserService) {
            $state.userConfig = userConfig;
            currentUserService.current.subscribe(u => {
                var message = u.bannerMessage();
                $scope.banner = {
                    enabled : !(message === '' || message === undefined),
                    message : message
                };
            });

            $scope.updateBanner = function (form) {
                var bannerEnabled = $scope.banner.enabled
                var body = {
                    enabled : bannerEnabled,
                    message : bannerEnabled ? $scope.banner.message : ''
                };

                if (form.$invalid) {
                    return
                }

                $http.post("/tradefloor/api/banner/enable", body).then(function () {
                    currentUserService.refreshConfig()
                }).catch((response) => {
                    $scope.newUserData.success = false
                    $scope.newUserData.failMessage = response.data.message

                    $scope.tags = []
                    currentUserService.refreshConfig()
                });
            };
        }])
        .controller('gameDashboardCtrl', ['$scope', '$state', '$http', '$aside', 'uiGridConstants', 'uiGridExporterConstants', 'userConfig', 'asxGameService', function gameDashboardController($scope, $state, $http, $aside, uiGridConstants, uiGridExporterConstants, userConfig, asxGameService) {

            $state.userConfig = userConfig;


            $scope.gameUserSummary = {
                activated : 0,
                tradedPort : 0,
                signedUp : 0
            };

            var fromPromise;

            if (userConfig.branding == 'GAME') {
                fromPromise = asxGameService.dates().then(function(dates) {
                    return DateTimeUtil.dateToIso(new Date(dates.opens));
                });
            } else {
                var fromDate = new Date();
                fromDate.setFullYear(fromDate.getFullYear() - 2);
                fromPromise = Promise.resolve(DateTimeUtil.dateToIso(fromDate));
            }

            fromPromise.then((from) => {
                $http.get('/tradefloor/api/user/game?fromDate=' + from)
                    .then(function(response) {
                        const fromMoment = moment(from).toDate();
                        $scope.gameUserSummary.gameStart = fromMoment;

                        var data = response.data;
                        $scope.userData = data;
                        $scope.userData.forEach(function(user){
                            var loggedInAfterGameStart = new Date(user.lastLogin) > fromMoment;

                            if (user.activatedDate != null) {
                                var activatedAfterGameStart = new Date(user.activatedDate) > fromMoment;
                                if (activatedAfterGameStart) {
                                    $scope.gameUserSummary.activated++;
                                }
                            }
                            if (user.tradeCount != null && user.tradeCount != 0) {
                                $scope.gameUserSummary.tradedPort++;
                            }

                            if (loggedInAfterGameStart) {
                                $scope.gameUserSummary.signedUp++;
                            }
                        });
                        $scope.gameDashboardGrid.data = data;
                    })
            });

            $scope.gameDashboardGrid = {
                flatEntityAccess : false,
                enableGridMenu: false,
                exporterMenuCsv: false,
                exporterMenuPdf: false,
                showColumnFooter: true,
                enableRowSelection: false,
                enableRowHeaderSelection: false,
                enableGrouping : false,
                enableColumnResizing: true,
                enableFiltering: true,
                saveFilter : true,
                saveSort : true,
                saveScroll : false,
                saveFocus : false,
                excessRows: 15,
                exporterCsvFilename: 'accounts.csv',
                minRowsToShow: 15,
                columnDefs: [
                    {
                        name: 'username',
                        type : 'string',
                        displayName: 'Username',
                        width: '*',
                        cellTemplate: '<div class="ngCellText ui-grid-cell-contents colt{{$index}}"><a ui-sref="viewprofile({userId : row.entity.id})">{{ row.entity[\'username\'] }}</a></div>',
                        cellTooltip: true
                    },
                    { field: 'displayName' },
                    { field: 'referer' },
                    { field: 'contactNumber' },
                    { field: 'created' },
                    { field: 'activatedDate' },
                    { field: 'age' },
                    { field: 'sharesExp' },
                    { field: 'optionsExp' },
                    { field: 'sophisticated', displayName: 'Sophisticated',
                        cellTemplate: '<div class="ngCellText ui-grid-cell-contents colt{{$index}}">{{row.entity.sophisticated ? \'Yes\' : \'\'}}</div>',

                    },
                    { field: 'brokerName', displayName: 'Broker'},
                    { field: 'postcode' },
                    { field: 'state' },
                    {
                        name: 'portfolioName',
                        type : 'string',
                        displayName: 'Portfolio',
                        width: '*',
                        cellTemplate: '<div class="ngCellText ui-grid-cell-contents colt{{$index}}"><a ui-sref="portfolio({portfolioId : row.entity.portfolioId})">{{ row.entity[\'portfolioName\'] }}</a></div>',
                        cellTooltip: true
                    },
                    { field: 'completeness', type : 'number', cellTooltip: true, headerCellClass: 'gridNumber', cellClass: 'gridNumber', footerCellClass: 'gridNumber' },
                    { field: 'tradeCount', type : 'number', cellTooltip: true, headerCellClass: 'gridNumber', cellClass: 'gridNumber', footerCellClass: 'gridNumber' },
                    { field: 'lastTrade', type : 'date', cellTooltip: true, headerCellClass: 'gridNumber', cellClass: 'gridNumber', footerCellClass: 'gridNumber', cellFilter: 'date: \'yyyy-MM-dd\''},
                    { field: 'loginCount', type : 'number', cellTooltip: true, headerCellClass: 'gridNumber', cellClass: 'gridNumber', footerCellClass: 'gridNumber' },
                    { field: 'lastLogin', type : 'date', cellTooltip: true, headerCellClass: 'gridNumber', cellClass: 'gridNumber', footerCellClass: 'gridNumber', cellFilter: 'date: \'yyyy-MM-dd\''},
                    {
                        name: 'totalBrokerage',
                        type : 'number', cellTooltip: true,
                        displayName: 'Total Brokerage',
                        headerCellClass: 'gridNumber', cellClass: 'gridNumber', footerCellClass: 'gridNumber',
                        cellFilter: 'ledger'
                    }

                ],
                onRegisterApi: function( gridApi ) {
                    $scope.gameDashboardGridApi = gridApi;
                }
            };

            $scope.openTablePrefs = function() {
                var position = 'right';
                var backdrop = true;

                $scope.asideState = {
                    open: true,
                    position: position
                };

                $aside.open({
                    templateUrl: '/tradefloor/app/layout/tablePrefs/openPosPref.html',
                    placement: position,
                    size: 'sm',
                    backdrop: backdrop,
                    controller : 'TablePrefCtrl',
                    resolve : {
                        gridApi : function() {
                            return $scope.gameDashboardGridApi;
                        }
                    }

                });
            };

            $scope.exportCsv = function () {
                $scope.gameDashboardGridApi.exporter.csvExport(uiGridExporterConstants.ALL, uiGridExporterConstants.ALL);
            };

            $scope.exportCsvVisible = function () {
                $scope.gameDashboardGridApi.exporter.csvExport(uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE);
            };

        }]);
}